export default __webpack_public_path__ + "static/media/yearBuilt.aa7613ce.svg";